
// Create the tooltips only when document ready
$(document).ready(function(){

	if ($('#nz-map').length > 0){

		require('../vendor/jquery.maphilight.min.js');
		require('../vendor/jquery.qtip-1.0.0-rc3.min.js');

		/**

		COMMENTED OUT DUE TO WEBPACK COMPATIBILITY ISSUES
		*/

		// $(function () {
		// 	$('.map').maphilight({ stroke: false, fillColor: '009DDF', fillOpacity: 0.5 });
		// });

		$(function(){
			$('map area').click(function(){
				var id = $(this).attr('alt')			
			});
		});	

		// Use the each() method to gain access to each elements attributes
		// $('area').each(function(){
		// 	$(this).qtip({
		// 		content: $(this).attr('alt'), // Use the ALT attribute of the area map
		// 		style: {
		// 			name: 'dark', // Give it the preset dark style
		// 			border: {
		// 			width: 0, 
		// 			radius: 4 
		// 		}, 
		// 		tip: true // Apply a tip at the default tooltip corner
		// 		}
		// 	});
		// });
	}
});
